var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.client.length > 0)?_c('FormulaireClient',{attrs:{"mode":"edit","client":_vm.client[0],"provenance":_vm.provenance}}):_c('div',[_vm._v("Ce client n'existe pas.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }